import { SURVEY_API_BASE } from '../../api/constants';

/**
 * Constructs the URL for marking a survey response instance as started.
 */
export function buildMarkAsStartedUrl(instanceId: string): string {
  const params = new URLSearchParams({ instanceId });
  return `${SURVEY_API_BASE}/markResponseInstanceAsStarted?${params.toString()}`;
}
